import React, { useState, useEffect } from "react";
import "../css/financials.css";
import { FaArrowRight, FaDownload } from "react-icons/fa";

function Financials() {
  const [financialData, setFinancialData] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    const fetchFinancialData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/financials/financials`
        );
        const result = await response.json();

        if (result.success) {
          setFinancialData(result.data.current);
        } else {
          console.error("Failed to fetch financial data");
        }
      } catch (error) {
        console.error("Error fetching financial data:", error);
      }
    };

    fetchFinancialData();
  }, []);

  const handleViewClick = (fileUrl) => {
    setSelectedPdf(fileUrl);
  };

  const handleClosePreview = () => {
    setSelectedPdf(null);
  };

  return (
    <div className="financials-container">
      <div className="content-director">
        <h3 className="director-heading">Financial Reports</h3>
        <p className="intro-text">
          Stay up to date with our latest financial reports. You can access and
          download the most recent financial data for your reference and review.
        </p>
      </div>

      <section className="pdf-links">
        <h2>Current Financial Reports</h2>
        <ul>
          {financialData.length === 0 ? (
            <li>No current financial data available. Please check back later.</li>
          ) : (
            financialData.map((data) => (
              <li key={data.year}>
                <div className="pdf-item">
                  <p className="year-title">
                    {data.title} - {data.year}
                  </p>
                  <a
                    href={data.file}
                    className="view-link"
                    onClick={() => handleViewClick(data.file)}
                  >
                    <FaArrowRight /> {/* Replace View Report with Right Arrow */}
                  </a>
                </div>
              </li>
            ))
          )}
        </ul>
      </section>
    </div>
  );
}

export default Financials;
